
export default {
	name: 'ChatAvatar',
	props: ['nickname', 'status', 'image', 'size', 'isGroup'],
	data () {
		return {
			
		}
	},
	computed: {
		myShow() {
			return this.status != 'offline';
		},
		avatarClass(){
			if(this.image && this.isGroup) return;
			return this.image? 'bg-white border border-white' : 'bg-theme text-white'
		}
	}
}
